export default {
  default: {
    title: 'No Image Libraries',
    paragraph: 'Your agency doesn’t have any image libraries yet. You can create image libraries to organise collections of images you want to use in your marketing pages.',
  },
}
